var WDN = WDN || {};

if (typeof WDN.CountrySelect === "undefined") {
  WDN.CountrySelect = (function () {
    var init, onLayoutRender, onLinkClick;

    // Instances
    var Renderer, Slides;

    // Nodes
    var nodes = {
      drawer: document.querySelector("wdn-drawer[data-id='countryselect']"),
    };

    // Redirect logic
    onLinkClick = function (e) {
      e.preventDefault();

      // Handle country that is not configured in localization - close drawer
      if (this.hasAttribute("data-close-drawer") && nodes.drawer) {
        nodes.drawer.close();
        return;
      }

      var host = this.getAttribute("data-host");
      var path = WDN.StoreHandlerConfig.currentStore.path;
      var params = this.getAttribute("data-params");

      // Set redirect URL
      var redirect_url = new URL(host + path + params);
      var current_search_params = new URLSearchParams(window.location.search);

      // Add params from the current href
      current_search_params.forEach((value, key) => {
        // Avoid overwriting new params
        if (!redirect_url.searchParams.has(key)) {
          redirect_url.searchParams.set(key, value);
        }
      });

      // Redirect
      window.location.href = redirect_url.href;
    };

    onLayoutRender = function () {
      document
        .querySelectorAll(".region-countries [data-code]")
        .forEach(function (link) {
          link.addEventListener("click", onLinkClick);
        });

      // Create slides module
      Slides = new WDN.Slides({
        group: "countryselect",
      });
    };

    // Logic for rendering drawer content async
    init = function () {
      Renderer = new WDN.SectionRenderer({
        selectors: {
          trigger: "wdn-drawer-open[data-id='countryselect']",
          output: "[data-country-list]",
        },
        replaceOutput: true,
        sections: ["async-country-list"],
        events: ["mouseover", "click"],
        callback: onLayoutRender,
      });

      Renderer.onInteraction = function () {
        WDN.StylesheetLoader.load(".countryselect-style");
      };

      // Listen for drawer close
      document.body.addEventListener("overlay:closed", function (e) {
        if (e.detail.id !== "countryselect") return;
        // Select back arrow
        var backArrow = document.querySelector(
          "[data-slide-to='back'][data-slide-group='countryselect']"
        );
        if (!backArrow) return;
        // Slide back to initial state (400ms delay for animation to finish)
        setTimeout(function () {
          backArrow.click();
        }, 400);
      });
    };

    init();

    return {
      Renderer,
      Slides,
    };
  })();
}
